<div class="flex-1 bg-slate-50/50 p-1 overflow-hidden flex flex-col h-full">
    <!-- Global Overlay for Filter Popup -->
    @if (activeFilterColumn()) {
    <div class="fixed inset-0 z-30" (click)="closeFilterPopup()"></div>
    }

    <div class="w-full h-full flex flex-col px-1">
        <!-- Header -->
        <header class="mb-2 flex justify-between items-center shrink-0 pt-2">
            <div class="flex items-center gap-4">
                <div>
                    <h1 class="text-lg font-bold text-slate-800 leading-tight">Replicador de Produtos Protheus</h1>
                    <p class="text-[10px] text-slate-500">Replicação de produtos cadastrados, alterados, bloqueados e
                        desbloqueados para todas as filiais</p>
                </div>
            </div>
            <div class="flex gap-2 items-center">
                @if (hasActiveFilters()) {
                <button (click)="clearAllFilters()"
                    class="flex items-center gap-1 px-2 py-1 text-[10px] font-bold text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors"
                    title="Remover todos os filtros">
                    <lucide-icon [img]="icons.FilterX" class="w-3.5 h-3.5"></lucide-icon>
                    Limpar Filtros
                </button>
                }
                <button (click)="loadData()"
                    class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-bold bg-indigo-600 text-white hover:bg-indigo-700 active:scale-95 transition-all cursor-pointer shadow-sm"
                    [disabled]="loading()">
                    <lucide-icon [img]="icons.RefreshCw"
                        [class]="'w-3.5 h-3.5' + (loading() ? ' animate-spin' : '')"></lucide-icon>
                    Atualizar
                </button>
            </div>
        </header>

        <!-- Grid -->
        <div
            class="bg-white rounded-xl shadow-sm border border-slate-200 relative flex-1 min-h-0 flex flex-col overflow-hidden">

            <!-- Loading Overlay -->
            @if (loading()) {
            <div class="absolute inset-0 bg-white/70 z-30 flex items-center justify-center">
                <div class="flex flex-col items-center gap-2">
                    <lucide-icon [img]="icons.Loader" class="w-6 h-6 text-indigo-500 animate-spin"></lucide-icon>
                    <span class="text-xs text-slate-500 font-medium">Carregando...</span>
                </div>
            </div>
            }

            <!-- Error State -->
            @if (error()) {
            <div class="absolute inset-0 bg-white z-30 flex items-center justify-center">
                <div class="flex flex-col items-center gap-3 text-center">
                    <div
                        class="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center border border-red-200">
                        <lucide-icon [img]="icons.AlertOctagon" class="w-6 h-6 text-red-500"></lucide-icon>
                    </div>
                    <p class="text-sm text-slate-600">{{ error() }}</p>
                    <button (click)="loadData()"
                        class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-bold bg-indigo-600 text-white hover:bg-indigo-700 active:scale-95 transition-all cursor-pointer shadow-sm">
                        <lucide-icon [img]="icons.RefreshCw" class="w-3.5 h-3.5"></lucide-icon>
                        Tentar novamente
                    </button>
                </div>
            </div>
            }

            <div class="overflow-auto flex-1">
                <table
                    class="w-full text-left border-collapse whitespace-nowrap table-fixed min-w-[1100px] transition-opacity duration-300">
                    <thead class="sticky top-0 shadow-sm" [style.z-index]="activeFilterColumn() ? 40 : 20">
                        <tr class="bg-slate-50 border-b border-slate-200">

                            <!-- Coluna: Ação (checkbox filter) -->
                            <th class="p-2 align-middle relative border-r border-slate-100 w-[8%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'actionType' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <span
                                        class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Ação</span>
                                    <button (click)="toggleFilterPopup('actionType', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterActionValues().size > 0">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                @if (activeFilterColumn() === 'actionType') {
                                <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Ação</span>
                                    </div>
                                    <div class="flex gap-2 mb-2">
                                        <button (click)="selectAllActions()"
                                            class="text-[10px] font-semibold text-indigo-600 hover:text-indigo-800">Selecionar
                                            todos</button>
                                        <span class="text-slate-300">|</span>
                                        <button (click)="clearActionSelection()"
                                            class="text-[10px] font-semibold text-slate-500 hover:text-slate-700">Limpar</button>
                                    </div>
                                    <div class="border border-slate-100 rounded-lg">
                                        @for (opt of actionOptions; track opt.value) {
                                        <label
                                            class="flex items-center gap-2 px-2 py-1.5 hover:bg-slate-50 cursor-pointer text-[11px] text-slate-700 border-b border-slate-50 last:border-0">
                                            <input type="checkbox" [checked]="filterActionValues().has(opt.value)"
                                                (change)="toggleActionFilter(opt.value)"
                                                class="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500">
                                            <span>{{ opt.label }}</span>
                                        </label>
                                        }
                                    </div>
                                    <div class="flex justify-between items-center border-t border-slate-100 pt-2 mt-2">
                                        <span class="text-[10px] text-slate-400">{{ filterActionValues().size }}
                                            selecionado(s)</span>
                                        <div class="flex gap-2">
                                            <button (click)="clearFilter('actionType')"
                                                class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                            <button (click)="closeFilterPopup()"
                                                class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                        </div>
                                    </div>
                                </div>
                                }
                            </th>

                            <!-- Coluna: Código (text filter) -->
                            <th class="p-2 align-middle relative border-r border-slate-100 w-[10%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'productCode' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <span
                                        class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Código</span>
                                    <button (click)="toggleFilterPopup('productCode', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterProductCode()">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                @if (activeFilterColumn() === 'productCode') {
                                <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-3">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Código</span>
                                    </div>
                                    <input type="text" [value]="filterProductCode()"
                                        (input)="filterProductCode.set($any($event.target).value)"
                                        class="w-full text-xs px-3 py-2 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-3 placeholder:text-slate-400"
                                        placeholder="Contém...">
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('productCode')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                                }
                            </th>

                            <!-- Coluna: Descrição (text filter) -->
                            <th class="p-2 align-middle relative border-r border-slate-100 w-[17%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'productDescription' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <span
                                        class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Descrição</span>
                                    <button (click)="toggleFilterPopup('productDescription', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterProductDescription()">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                @if (activeFilterColumn() === 'productDescription') {
                                <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-3">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Descrição</span>
                                    </div>
                                    <input type="text" [value]="filterProductDescription()"
                                        (input)="filterProductDescription.set($any($event.target).value)"
                                        class="w-full text-xs px-3 py-2 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-3 placeholder:text-slate-400"
                                        placeholder="Contém...">
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('productDescription')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                                }
                            </th>

                            <!-- Coluna: Cód. Fluig (text filter) -->
                            <th class="p-2 align-middle relative border-r border-slate-100 w-[7%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'fluigCode' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <span class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Cód.
                                        Fluig</span>
                                    <button (click)="toggleFilterPopup('fluigCode', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterFluigCode()">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                @if (activeFilterColumn() === 'fluigCode') {
                                <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-3">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Cód. Fluig</span>
                                    </div>
                                    <input type="text" [value]="filterFluigCode()"
                                        (input)="filterFluigCode.set($any($event.target).value)"
                                        class="w-full text-xs px-3 py-2 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-3 placeholder:text-slate-400"
                                        placeholder="Contém...">
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('fluigCode')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                                }
                            </th>

                            <!-- Coluna: Data Solicitação (date range filter) -->
                            <th class="p-2 align-middle relative border-r border-slate-100 w-[11%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'requestedAt' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <span class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Data
                                        Solicitação</span>
                                    <button (click)="toggleFilterPopup('requestedAt', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterDateStart() || filterDateEnd()">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                @if (activeFilterColumn() === 'requestedAt') {
                                <div class="absolute left-0 top-full mt-2 w-60 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default overflow-hidden"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar por Período</span>
                                    </div>
                                    <div class="flex items-center gap-2 mb-2">
                                        <label
                                            class="text-[10px] font-semibold text-slate-500 uppercase w-6 shrink-0">De</label>
                                        <input type="date" [value]="filterDateStart()"
                                            (input)="filterDateStart.set($any($event.target).value)"
                                            class="flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none">
                                    </div>
                                    <div class="flex items-center gap-2 mb-3">
                                        <label
                                            class="text-[10px] font-semibold text-slate-500 uppercase w-6 shrink-0">Até</label>
                                        <input type="date" [value]="filterDateEnd()"
                                            (input)="filterDateEnd.set($any($event.target).value)"
                                            class="flex-1 min-w-0 text-xs px-2 py-1.5 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none">
                                    </div>
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('requestedAt')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                                }
                            </th>

                            <!-- Coluna: Solicitante (text filter) -->
                            <th class="p-2 align-middle relative border-r border-slate-100 w-[13%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'requestedBy' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <span
                                        class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Solicitante</span>
                                    <button (click)="toggleFilterPopup('requestedBy', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterRequestedBy()">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                @if (activeFilterColumn() === 'requestedBy') {
                                <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-3">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Solicitante</span>
                                    </div>
                                    <input type="text" [value]="filterRequestedBy()"
                                        (input)="filterRequestedBy.set($any($event.target).value)"
                                        class="w-full text-xs px-3 py-2 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-3 placeholder:text-slate-400"
                                        placeholder="Contém...">
                                    <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                        <button (click)="clearFilter('requestedBy')"
                                            class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                        <button (click)="closeFilterPopup()"
                                            class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                    </div>
                                </div>
                                }
                            </th>

                            <!-- Coluna: Status (checkbox filter) -->
                            <th class="p-2 align-middle relative border-r border-slate-100 w-[12%] sticky top-0"
                                [style.z-index]="activeFilterColumn() === 'status' ? 50 : 20">
                                <div class="flex items-center justify-between gap-1">
                                    <span
                                        class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Status</span>
                                    <button (click)="toggleFilterPopup('status', $event)"
                                        class="text-slate-400 hover:text-indigo-600 p-0.5 rounded transition-colors focus:outline-none shrink-0"
                                        [class.text-red-500]="filterStatusValues().size > 0">
                                        <lucide-icon [img]="icons.Filter" class="w-3 h-3"></lucide-icon>
                                    </button>
                                </div>
                                @if (activeFilterColumn() === 'status') {
                                <div class="absolute right-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-50 text-left cursor-default"
                                    (click)="$event.stopPropagation()">
                                    <div class="flex items-center gap-2 mb-2">
                                        <lucide-icon [img]="icons.Filter"
                                            class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                        <span class="text-xs font-bold text-slate-700">Filtrar Status</span>
                                    </div>
                                    <div class="flex gap-2 mb-2">
                                        <button (click)="selectAllStatuses()"
                                            class="text-[10px] font-semibold text-indigo-600 hover:text-indigo-800">Selecionar
                                            todos</button>
                                        <span class="text-slate-300">|</span>
                                        <button (click)="clearStatusSelection()"
                                            class="text-[10px] font-semibold text-slate-500 hover:text-slate-700">Limpar</button>
                                    </div>
                                    <div class="border border-slate-100 rounded-lg">
                                        @for (opt of statusOptions; track opt.value) {
                                        <label
                                            class="flex items-center gap-2 px-2 py-1.5 hover:bg-slate-50 cursor-pointer text-[11px] text-slate-700 border-b border-slate-50 last:border-0">
                                            <input type="checkbox" [checked]="filterStatusValues().has(opt.value)"
                                                (change)="toggleStatusFilter(opt.value)"
                                                class="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500">
                                            <span>{{ opt.label }}</span>
                                        </label>
                                        }
                                    </div>
                                    <div class="flex justify-between items-center border-t border-slate-100 pt-2 mt-2">
                                        <span class="text-[10px] text-slate-400">{{ filterStatusValues().size }}
                                            selecionado(s)</span>
                                        <div class="flex gap-2">
                                            <button (click)="clearFilter('status')"
                                                class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                            <button (click)="closeFilterPopup()"
                                                class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                        </div>
                                    </div>
                                </div>
                                }
                            </th>

                            <!-- Coluna: Progresso -->
                            <th class="p-2 align-middle border-r border-slate-100 w-[13%] sticky top-0">
                                <span
                                    class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Progresso</span>
                            </th>

                            <!-- Coluna: Detalhes -->
                            <th class="p-2 align-middle w-[6%] sticky top-0 text-center">
                                <span
                                    class="text-[10px] font-bold uppercase tracking-wider text-slate-600">Detalhes</span>
                            </th>

                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-100">
                        @if (filteredReplications().length === 0 && !loading()) {
                        <tr>
                            <td colspan="9" class="p-8 text-center text-slate-400 text-sm">Nenhuma replicação
                                encontrada.</td>
                        </tr>
                        }
                        @for (item of filteredReplications(); track item.uuid) {
                        <tr class="hover:bg-slate-50 transition-colors text-sm text-slate-700">

                            <!-- Ação -->
                            <td class="p-2">
                                <span
                                    [class]="'inline-flex items-center gap-1 px-2 py-1 rounded-md text-[10px] font-bold border shadow-sm whitespace-nowrap ' + getActionColor(item.actionType)">
                                    <lucide-icon [img]="getActionIcon(item.actionType)"
                                        class="w-3 h-3 shrink-0"></lucide-icon>
                                    {{ item.actionType }}
                                </span>
                            </td>

                            <!-- Código -->
                            <td class="p-2">
                                <span class="font-mono font-semibold text-slate-700 text-[13px]">{{ item.productCode
                                    }}</span>
                            </td>

                            <!-- Descrição -->
                            <td class="p-2 truncate" [title]="item.productDescription">
                                <span class="text-[13px] text-slate-600">{{ item.productDescription }}</span>
                            </td>

                            <!-- Cód. Fluig -->
                            <td class="p-2">
                                <span class="font-mono text-[12px] text-indigo-600 font-semibold">{{ item.fluigCode
                                    }}</span>
                            </td>

                            <!-- Data Solicitação -->
                            <td class="p-2 text-[13px] text-slate-600">
                                {{ formatDate(item.requestedAt) }}
                            </td>

                            <!-- Solicitante -->
                            <td class="p-2 truncate" [title]="item.requestedBy || ''">
                                @if (item.requestedBy) {
                                <span class="text-[12px] text-slate-600">{{ item.requestedBy }}</span>
                                } @else {
                                <span class="text-[11px] text-slate-300">—</span>
                                }
                            </td>

                            <!-- Status -->
                            <td class="p-2">
                                <span
                                    [class]="'inline-flex items-center gap-1 px-2 py-1 rounded-md text-[10px] font-bold border shadow-sm whitespace-nowrap ' + getStatusColor(item.status)">
                                    <lucide-icon [img]="getStatusIcon(item.status)"
                                        [class]="'w-3 h-3 shrink-0' + (item.status === 'Em Replicação' ? ' animate-spin-slow' : '')"></lucide-icon>
                                    {{ item.status }}
                                </span>
                            </td>

                            <!-- Progresso -->
                            <td class="p-2">
                                @if (item.branchSummary) {
                                <div class="flex flex-col gap-0.5">
                                    <div class="flex items-center justify-between">
                                        <span class="text-[10px] font-bold text-slate-600">{{
                                            getSuccessPercentage(item.branchSummary) }}%</span>
                                        <span class="text-[9px] text-slate-400">{{ item.branchSummary.success }}/{{
                                            item.branchSummary.total }}</span>
                                    </div>
                                    <div class="w-full h-1.5 bg-slate-100 rounded-full overflow-hidden">
                                        <div [class]="'h-full rounded-full transition-all duration-500 ease-out ' + getProgressBarColor(getSuccessPercentage(item.branchSummary))"
                                            [style.width.%]="getSuccessPercentage(item.branchSummary)">
                                        </div>
                                    </div>
                                    @if (item.branchSummary.error > 0) {
                                    <span class="text-[9px] text-red-500 font-semibold">{{ item.branchSummary.error }}
                                        erro(s)</span>
                                    }
                                    @if (item.branchSummary.pending > 0) {
                                    <span class="text-[9px] text-slate-400 font-medium">{{ item.branchSummary.pending }}
                                        pendente(s)</span>
                                    }
                                </div>
                                } @else {
                                <span class="text-[10px] text-slate-300">—</span>
                                }
                            </td>

                            <!-- Detalhes -->
                            <td class="p-2 text-center">
                                <button (click)="openDetails(item)"
                                    class="inline-flex items-center justify-center w-7 h-7 rounded-lg bg-indigo-50 text-indigo-600 hover:bg-indigo-100 active:scale-95 transition-all cursor-pointer border border-indigo-200"
                                    title="Ver detalhes das filiais">
                                    <lucide-icon [img]="icons.Eye" class="w-3.5 h-3.5"></lucide-icon>
                                </button>
                            </td>

                        </tr>
                        }
                    </tbody>
                </table>
            </div>

            <!-- Footer -->
            <div
                class="px-3 py-1.5 bg-slate-50 border-t border-slate-200 text-[10px] text-slate-500 font-medium flex justify-between items-center shrink-0">
                <span>Total: <b class="text-slate-700">{{ filteredReplications().length }}</b> replicações</span>
            </div>
        </div>
    </div>

    <!-- Details Modal -->
    @if (isModalOpen) {
    <div
        class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-fade-in">

        <!-- Detail filter overlay -->
        @if (activeDetailFilter()) {
        <div class="fixed inset-0 z-[101]" (click)="closeDetailFilterPopup()"></div>
        }

        <div
            class="bg-white rounded-2xl shadow-2xl max-w-3xl w-full h-[80vh] overflow-hidden z-[102] relative flex flex-col animate-slide-up">

            <!-- Modal Header -->
            <div class="p-4 border-b border-slate-200 shrink-0">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-3">
                        <div
                            class="w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white shadow-lg shadow-indigo-500/20">
                            <lucide-icon [img]="icons.Package" class="w-4.5 h-4.5"></lucide-icon>
                        </div>
                        <div>
                            <h3 class="text-sm font-bold text-slate-800">Detalhes da Replicação</h3>
                            <p class="text-[10px] text-slate-500">Dados do produto e status por filial</p>
                        </div>
                    </div>
                    <button (click)="closeDetails()"
                        class="w-7 h-7 rounded-lg bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors cursor-pointer">
                        <lucide-icon [img]="icons.X" class="w-3.5 h-3.5 text-slate-500"></lucide-icon>
                    </button>
                </div>
            </div>

            <!-- Modal Body (fixed height via flex-1 + overflow) -->
            <div class="flex-1 overflow-auto p-4 min-h-0">

                <!-- Loading state -->
                @if (detailLoading()) {
                <div class="flex flex-col items-center justify-center py-12 gap-3">
                    <lucide-icon [img]="icons.Loader" class="w-8 h-8 text-indigo-500 animate-spin"></lucide-icon>
                    <span class="text-sm text-slate-500">Carregando detalhes...</span>
                </div>
                }

                <!-- Error state -->
                @if (detailError()) {
                <div class="flex flex-col items-center justify-center py-12 gap-3">
                    <div
                        class="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center border border-red-200">
                        <lucide-icon [img]="icons.AlertOctagon" class="w-6 h-6 text-red-500"></lucide-icon>
                    </div>
                    <p class="text-sm text-slate-600">{{ detailError() }}</p>
                </div>
                }

                <!-- Detail content -->
                @if (selectedDetail(); as detail) {

                <!-- Product Data Card (only code and description) -->
                <div class="mb-3 rounded-xl border border-slate-200 bg-slate-50/50 p-3">
                    <div class="flex items-center gap-2 mb-2">
                        <lucide-icon [img]="icons.Info" class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                        <h4 class="text-[12px] font-bold text-slate-700">Dados do Produto</h4>
                    </div>
                    <div class="grid grid-cols-2 gap-x-6 gap-y-2">
                        <div>
                            <span class="text-[10px] text-slate-400 uppercase tracking-wider">Código</span>
                            <p class="text-[11px] font-mono font-bold text-slate-800">{{ detail.productData.code }}</p>
                        </div>
                        <div>
                            <span class="text-[10px] text-slate-400 uppercase tracking-wider">Descrição</span>
                            <p class="text-[11px] font-bold text-slate-800">{{ detail.productData.description }}</p>
                        </div>
                        @if (detail.requestedBy) {
                        <div class="col-span-2">
                            <span class="text-[10px] text-slate-400 uppercase tracking-wider">Solicitante</span>
                            <p class="text-[11px] font-semibold text-slate-800">{{ detail.requestedBy }}</p>
                        </div>
                        }
                    </div>
                </div>

                <!-- Branch count badges + filter button -->
                <div class="mb-2 flex items-center justify-between flex-wrap gap-1">
                    <div class="flex gap-1.5 flex-wrap">
                        <span
                            class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-slate-100 text-slate-600 border border-slate-200">
                            Total: {{ detailBranchCounts().total }}
                        </span>
                        <span
                            class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-emerald-50 text-emerald-700 border border-emerald-200">
                            <lucide-icon [img]="icons.Check" class="w-2 h-2"></lucide-icon>
                            {{ detailBranchCounts().success }}
                        </span>
                        @if (detailBranchCounts().error > 0) {
                        <span
                            class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-red-50 text-red-700 border border-red-200">
                            <lucide-icon [img]="icons.AlertOctagon" class="w-2 h-2"></lucide-icon>
                            {{ detailBranchCounts().error }}
                        </span>
                        }
                        @if (detailBranchCounts().processing > 0) {
                        <span
                            class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-blue-50 text-blue-700 border border-blue-200">
                            <lucide-icon [img]="icons.Loader" class="w-2 h-2"></lucide-icon>
                            {{ detailBranchCounts().processing }}
                        </span>
                        }
                        @if (detailBranchCounts().pending > 0) {
                        <span
                            class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-slate-50 text-slate-600 border border-slate-200">
                            <lucide-icon [img]="icons.Clock" class="w-2 h-2"></lucide-icon>
                            {{ detailBranchCounts().pending }}
                        </span>
                        }
                    </div>
                    <div class="flex items-center gap-2">
                        @if (errorBranchesInView().length > 0) {
                        @if (authService.hasRole(['Admin', 'Operator', 'ProductSyncOperator'])) {
                        <button (click)="selectAllErrorBranches()"
                            class="inline-flex items-center gap-1 px-1.5 py-0.5 text-[9px] font-bold text-indigo-600 bg-indigo-50 hover:bg-indigo-100 rounded-lg border border-indigo-200 transition-colors"
                            title="Selecionar todas as filiais com erro">
                            <lucide-icon [img]="icons.Check" class="w-2 h-2"></lucide-icon>
                            Selecionar com erro ({{ errorBranchesInView().length }})
                        </button>
                        }
                        @if (selectedBranchCount() > 0) {
                        <button (click)="clearBranchSelection()"
                            class="text-[9px] font-semibold text-slate-400 hover:text-slate-600 transition-colors">
                            Limpar seleção ({{ selectedBranchCount() }})
                        </button>
                        }
                        @if (hasActiveDetailFilters()) {
                        <button (click)="clearAllDetailFilters()"
                            class="flex items-center gap-1 px-1.5 py-0.5 text-[9px] font-bold text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors"
                            title="Limpar filtros do detalhe">
                            <lucide-icon [img]="icons.FilterX" class="w-2.5 h-2.5"></lucide-icon>
                            Limpar filtros
                        </button>
                        }
                        }
                    </div>
                </div>

                <!-- Detail Filters Row -->
                <div class="mb-2 flex gap-2 relative">
                    <!-- Branch Code Filter -->
                    <div class="relative">
                        <button (click)="toggleDetailFilterPopup('branchCode', $event)"
                            class="inline-flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-semibold border transition-colors"
                            [class]="detailBranchFilter() ? 'bg-indigo-50 text-indigo-700 border-indigo-200' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'">
                            <lucide-icon [img]="icons.Filter" class="w-2.5 h-2.5"></lucide-icon>
                            Filial
                            @if (detailBranchFilter()) {
                            <span
                                class="bg-indigo-600 text-white text-[8px] px-1 py-0.5 rounded-full font-bold">1</span>
                            }
                        </button>
                        @if (activeDetailFilter() === 'branchCode') {
                        <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-[110] text-left cursor-default"
                            (click)="$event.stopPropagation()">
                            <div class="flex items-center gap-2 mb-3">
                                <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                <span class="text-xs font-bold text-slate-700">Filtrar por Filial</span>
                            </div>
                            <input type="text" [value]="detailBranchFilter()"
                                (input)="detailBranchFilter.set($any($event.target).value)"
                                class="w-full text-xs px-3 py-2 rounded-lg border border-slate-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none mb-3 placeholder:text-slate-400"
                                placeholder="Código da filial...">
                            <div class="flex justify-end gap-2 border-t border-slate-100 pt-2">
                                <button (click)="clearDetailBranchFilter()"
                                    class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                <button (click)="closeDetailFilterPopup()"
                                    class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                            </div>
                        </div>
                        }
                    </div>

                    <!-- Status Filter -->
                    <div class="relative">
                        <button (click)="toggleDetailFilterPopup('status', $event)"
                            class="inline-flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-semibold border transition-colors"
                            [class]="detailStatusFilter().size > 0 ? 'bg-indigo-50 text-indigo-700 border-indigo-200' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'">
                            <lucide-icon [img]="icons.Filter" class="w-2.5 h-2.5"></lucide-icon>
                            Status
                            @if (detailStatusFilter().size > 0) {
                            <span class="bg-indigo-600 text-white text-[8px] px-1 py-0.5 rounded-full font-bold">{{
                                detailStatusFilter().size }}</span>
                            }
                        </button>
                        @if (activeDetailFilter() === 'status') {
                        <div class="absolute left-0 top-full mt-2 w-56 bg-white rounded-xl shadow-2xl border border-slate-200 p-3 z-[110] text-left cursor-default"
                            (click)="$event.stopPropagation()">
                            <div class="flex items-center gap-2 mb-2">
                                <lucide-icon [img]="icons.Filter" class="w-3.5 h-3.5 text-indigo-500"></lucide-icon>
                                <span class="text-xs font-bold text-slate-700">Filtrar Status</span>
                            </div>
                            <div class="border border-slate-100 rounded-lg">
                                @for (opt of detailBranchStatusOptions; track opt.value) {
                                <label
                                    class="flex items-center gap-2 px-2 py-1.5 hover:bg-slate-50 cursor-pointer text-[11px] text-slate-700 border-b border-slate-50 last:border-0">
                                    <input type="checkbox" [checked]="detailStatusFilter().has(opt.value)"
                                        (change)="toggleDetailStatusFilter(opt.value)"
                                        class="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500">
                                    <span>{{ opt.label }}</span>
                                </label>
                                }
                            </div>
                            <div class="flex justify-between items-center border-t border-slate-100 pt-2 mt-2">
                                <span class="text-[10px] text-slate-400">{{ detailStatusFilter().size }}
                                    selecionado(s)</span>
                                <div class="flex gap-2">
                                    <button (click)="clearDetailStatusFilter()"
                                        class="text-[11px] font-semibold text-slate-500 hover:text-slate-800 px-2 py-1">Limpar</button>
                                    <button (click)="closeDetailFilterPopup()"
                                        class="text-[11px] font-bold bg-indigo-600 text-white px-3 py-1.5 rounded-lg hover:bg-indigo-700 shadow-sm">Aplicar</button>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>

                <!-- Branches List (compact rows) -->
                <div class="space-y-1">
                    @if (filteredDetailBranches().length === 0) {
                    <div class="p-4 text-center text-slate-400 text-xs">
                        Nenhuma filial encontrada para os filtros aplicados.
                    </div>
                    }
                    @for (branch of filteredDetailBranches(); track branch.branchCode) {
                    <div [class]="'rounded-lg border px-3 py-2 transition-all ' +
                            (branch.syncStatus.toLowerCase() === 'error' ? 'border-red-200 bg-red-50/30' :
                             branch.syncStatus.toLowerCase() === 'success' ? 'border-emerald-200 bg-emerald-50/30' :
                             branch.syncStatus.toLowerCase() === 'processing' ? 'border-blue-200 bg-blue-50/30' :
                             branch.syncStatus.toLowerCase() === 'cancelled' ? 'border-orange-200 bg-orange-50/30' :
                             'border-slate-200 bg-slate-50/30')">

                        <div class="flex items-center justify-between">
                            <div class="flex items-center gap-2 min-w-0 flex-1">
                                <!-- Checkbox for multi-select (error branches only, write roles) -->
                                @if (branch.syncStatus.toLowerCase() === 'error' && authService.hasRole(['Admin', 'Operator', 'ProductSyncOperator'])) {
                                <input type="checkbox"
                                    [checked]="selectedBranchUuids().has(branch.uuid)"
                                    (change)="toggleBranchSelection(branch.uuid)"
                                    (click)="$event.stopPropagation()"
                                    class="w-3.5 h-3.5 rounded border-red-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer shrink-0"
                                    title="Selecionar para reprocessamento em lote">
                                }

                                <!-- Status Icon -->
                                <div [class]="'w-5 h-5 rounded flex items-center justify-center shrink-0 ' +
                                        (branch.syncStatus.toLowerCase() === 'error' ? 'bg-red-100 text-red-600' :
                                         branch.syncStatus.toLowerCase() === 'success' ? 'bg-emerald-100 text-emerald-600' :
                                         branch.syncStatus.toLowerCase() === 'processing' ? 'bg-blue-100 text-blue-600' :
                                         branch.syncStatus.toLowerCase() === 'cancelled' ? 'bg-orange-100 text-orange-600' :
                                         'bg-slate-100 text-slate-500')">
                                    <lucide-icon [img]="getBranchStatusIcon(mapBranchStatus(branch.syncStatus))"
                                        [class]="'w-3 h-3' + (branch.syncStatus.toLowerCase() === 'processing' ? ' animate-spin-slow' : '')"></lucide-icon>
                                </div>

                                <!-- Branch Info -->
                                <span class="text-[11px] font-mono font-bold text-slate-800">{{ branch.branchCode
                                    }}</span>
                            </div>

                            <div class="flex items-center gap-2 shrink-0">
                                <!-- Retry Button (error status + write roles only) -->
                                @if (branch.syncStatus.toLowerCase() === 'error' && authService.hasRole(['Admin', 'Operator', 'ProductSyncOperator'])) {
                                <button (click)="confirmRetryBranch(branch.uuid, branch.branchCode)"
                                    [disabled]="retryingUuids().has(branch.uuid)"
                                    class="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[9px] font-bold border shadow-sm whitespace-nowrap bg-red-50 text-red-700 border-red-200 hover:bg-red-600 hover:text-white hover:border-red-600 active:scale-95 transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                                    title="Reprocessar filial">
                                    @if (retryingUuids().has(branch.uuid)) {
                                    <lucide-icon [img]="icons.Loader"
                                        class="w-3 h-3 animate-spin shrink-0"></lucide-icon>
                                    Reprocessando...
                                    } @else {
                                    <lucide-icon [img]="icons.RefreshCw" class="w-3 h-3 shrink-0"></lucide-icon>
                                    Reprocessar
                                    }
                                </button>
                                }

                                <!-- Status Badge -->
                                <span
                                    [class]="'inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-bold border shadow-sm whitespace-nowrap ' + getBranchStatusColor(mapBranchStatus(branch.syncStatus))">
                                    {{ mapBranchStatus(branch.syncStatus) }}
                                </span>
                            </div>
                        </div>

                        <!-- Error Message -->
                        @if (branch.syncStatus.toLowerCase() === 'error' && branch.errorMessage) {
                        <div class="mt-1.5 p-1.5 bg-red-50 border border-red-100 rounded-lg">
                            <p class="text-[10px] text-red-600 leading-relaxed whitespace-pre-wrap">
                                <lucide-icon [img]="icons.AlertCircle"
                                    class="w-2.5 h-2.5 inline-block mr-0.5 align-middle"></lucide-icon>
                                {{ sanitizeErrorMessage(branch.errorMessage) }}
                            </p>
                        </div>
                        }
                    </div>
                    }
                </div>

                <!-- Filtered count -->
                @if (hasActiveDetailFilters()) {
                <div class="mt-2 text-[10px] text-slate-400 text-center">
                    Exibindo <b class="text-slate-600">{{ filteredDetailBranches().length }}</b> de <b
                        class="text-slate-600">{{ detailBranchCounts().total }}</b> filiais
                </div>
                }
                }
            </div>

            <!-- Modal Footer -->
            <div class="p-3 border-t border-slate-200 shrink-0 flex items-center justify-between gap-3">
                <!-- Bulk retry action -->
                @if (selectedBranchCount() > 0) {
                <div class="flex items-center gap-2">
                    <span class="text-[11px] text-slate-500">
                        <b class="text-indigo-600">{{ selectedBranchCount() }}</b> filial(is) selecionada(s)
                    </span>
                    <button (click)="confirmRetrySelected()"
                        class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-bold bg-indigo-600 text-white hover:bg-indigo-700 active:scale-95 transition-all cursor-pointer shadow-sm">
                        <lucide-icon [img]="icons.RefreshCw" class="w-3 h-3"></lucide-icon>
                        Reprocessar {{ selectedBranchCount() }} selecionada(s)
                    </button>
                </div>
                } @else {
                <span></span>
                }
                <button (click)="closeDetails()"
                    class="px-3 py-1.5 text-xs font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors cursor-pointer">
                    Fechar
                </button>
            </div>
        </div>
    </div>
    }

    <!-- MODAL CONFIRMAÇÃO DE REPROCESSAR FILIAL(IS) -->
    @if (pendingRetryUuids().length > 0) {
    <div
        class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[200] flex items-center justify-center p-4 animate-fade-in">
        <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 overflow-hidden">
            <div class="flex items-center gap-4 mb-4">
                <div
                    class="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 shrink-0">
                    <lucide-icon [img]="icons.AlertCircle" class="w-6 h-6"></lucide-icon>
                </div>
                <h3 class="text-lg font-bold text-slate-800">Reprocessar Filial{{ pendingRetryUuids().length > 1 ? 'is' : '' }}</h3>
            </div>
            <p class="text-sm text-slate-600 mb-8 leading-relaxed">
                @if (pendingRetryUuids().length === 1) {
                Deseja realmente reprocessar a filial
                <span class="font-bold text-slate-800">{{ pendingRetryCodes()[0] }}</span>?
                } @else {
                Deseja realmente reprocessar as
                <span class="font-bold text-slate-800">{{ pendingRetryUuids().length }} filiais</span>
                selecionadas?
                }
                A sincronização será tentada novamente.
            </p>
            <div class="flex justify-end gap-3">
                <button (click)="cancelRetryBranch()"
                    class="px-4 py-2 text-sm font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors">
                    Cancelar
                </button>
                <button (click)="executeRetryBranch()"
                    class="px-4 py-2 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-lg transition-colors shadow-sm flex items-center gap-2">
                    <lucide-icon [img]="icons.Play" class="w-3.5 h-3.5"></lucide-icon> Sim, Reprocessar
                </button>
            </div>
        </div>
    </div>
    }

    <!-- MODAL ERRO DE AÇÃO -->
    @if (retryErrorMessage()) {
    <div
        class="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[200] flex items-center justify-center p-4 animate-fade-in">
        <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 overflow-hidden">
            <div class="flex items-center gap-4 mb-4">
                <div class="w-12 h-12 rounded-full bg-rose-100 flex items-center justify-center text-rose-600 shrink-0">
                    <lucide-icon [img]="icons.AlertCircle" class="w-6 h-6"></lucide-icon>
                </div>
                <h3 class="text-lg font-bold text-slate-800">Erro na Operação</h3>
            </div>
            <p class="text-sm text-slate-600 mb-8 leading-relaxed">
                {{ retryErrorMessage() }}
            </p>
            <div class="flex justify-end">
                <button (click)="retryErrorMessage.set(null)"
                    class="px-4 py-2 text-sm font-medium text-white bg-rose-600 hover:bg-rose-700 rounded-lg transition-colors shadow-sm">
                    Fechar
                </button>
            </div>
        </div>
    </div>
    }
</div>